import { render, staticRenderFns } from "./CardContentDesc.vue?vue&type=template&id=3f5ee5ec&scoped=true"
import script from "./CardContentDesc.vue?vue&type=script&lang=ts"
export * from "./CardContentDesc.vue?vue&type=script&lang=ts"
import style0 from "./CardContentDesc.vue?vue&type=style&index=0&id=3f5ee5ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5ee5ec",
  null
  
)

export default component.exports